










import { editFactory } from '@/main/pages';
import { apiProvider as segmentCategoryProvider } from '@/modules/oem/CorporateSegment/segmentcategory/api';

import { AUTH_LOGOUT, AUTH_USER, SSO_SIGNOUT } from '@/main/store/actionTypes';
import { mapActions } from 'vuex';
import { openList } from '@/main/router/routerPath';


import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	methods: {
		...mapActions({
			clearPages: `pageManager/${'PAGE_MGR_CLEAR'}`,
			logoutUser: AUTH_LOGOUT,
			SSOLogout: SSO_SIGNOUT,
			authUser: AUTH_USER,
		}),
		async saveClick() {
			if (await this.validate()) {
				this.startLoading();
				const { data: result } = await segmentCategoryProvider.saveSegmentCategoryData(this.edit);
				if (result.Status === '1' && result.UserMessage) {
					this.showNotification({
						title: this.Localize('DMS3_SuccessTitle'),
						message: this.LocalizePopisPoli(result.UserMessage),
						type: 'success',
					});
				} else {
					this.showErrorAlert({ message: this.LocalizePopisPoli(result.UserMessage) });
					this.endLoading();
					return false;
				}
				this.refreshPreviousPage = true;
				this.openSegmentCategoryList();
				this.endLoading();
			}
			return true;
		},
		async deleteClick() {
			this.startLoading();
			const { data: result } = await segmentCategoryProvider.deleteSegmentCategoryData(this.edit.Id);
			if (result.Status === '1' && result.UserMessage) {
				this.showNotification({
					title: this.Localize('DMS3_SuccessTitle'),
					message: this.LocalizePopisPoli(result.UserMessage),
					type: 'success',
				});
			} else {
				this.showErrorAlert({ message: this.LocalizePopisPoli(result.UserMessage) });
				this.endLoading();
				return false;
			}
			this.refreshPreviousPage = true;
			this.openSegmentCategoryList();
			this.endLoading();
			return true;
		},
		async openSegmentCategoryList(checkFilters = true) {
			await this.clearPages();
			openList(NAME, { checkFilters });
		},
	},
});
